'use es6';

import { DASHBOARD_PERMISSION_DENIED, DASHBOARD_REPORT_LIMIT_REACHED_OR_EXCEEDED, LOADING, TARGET_IS_READ_ONLY_DEMO_PROBLEM, USER_SETTINGS_LACK_EDIT } from 'dashboard-lib/private/action-problem-solution/actions/add-static-widget-to-dashboard/problem';
import { getAndCheck } from 'dashboard-lib/private/action-problem-solution/common/get-and-check-param';
import { DASHBOARD_REPORT_LIMIT } from 'dashboard-lib/private/action-problem-solution/params/all-params';
import { indexBy } from 'dashboard-lib/private/js-util';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { createDisabledMessage } from '../common/disabled-message';
import { createReactMessage, getId } from '../common/message';
import { jsx as _jsx } from "react/jsx-runtime";
const SharedProblemMessages = [createReactMessage(LOADING, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.ADD_STATIC_WIDGET.problem.LOADING"
})), createReactMessage(DASHBOARD_REPORT_LIMIT_REACHED_OR_EXCEEDED, params => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reportingActions.ADD_STATIC_WIDGET.problem.DASHBOARD_REPORT_LIMIT_REACHED_OR_EXCEEDED",
    options: {
      limit: getAndCheck(DASHBOARD_REPORT_LIMIT, params)
    }
  });
})];
const AddNoteProblemMessages = SharedProblemMessages.concat([createReactMessage(USER_SETTINGS_LACK_EDIT, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.ADD_STATIC_WIDGET.problem.USER_SETTINGS_LACK_EDIT.note"
})), createReactMessage(DASHBOARD_PERMISSION_DENIED, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.ADD_STATIC_WIDGET.problem.DASHBOARD_PERMISSION_DENIED.note"
})), createReactMessage(TARGET_IS_READ_ONLY_DEMO_PROBLEM, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.ADD_STATIC_WIDGET.problem.TARGET_IS_READ_ONLY_DEMO_PROBLEM.note"
}))]);
const AddIframeProblemMessages = SharedProblemMessages.concat([createReactMessage(USER_SETTINGS_LACK_EDIT, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.ADD_STATIC_WIDGET.problem.USER_SETTINGS_LACK_EDIT.iframe"
})), createReactMessage(DASHBOARD_PERMISSION_DENIED, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.ADD_STATIC_WIDGET.problem.DASHBOARD_PERMISSION_DENIED.iframe"
})), createReactMessage(TARGET_IS_READ_ONLY_DEMO_PROBLEM, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.ADD_STATIC_WIDGET.problem.TARGET_IS_READ_ONLY_DEMO_PROBLEM.iframe"
}))]);
const _addNoteProblemToMessage = indexBy(getId, AddNoteProblemMessages);
const _addIframeProblemToMessage = indexBy(getId, AddIframeProblemMessages);
export function getAddNoteDisabledMessage(params, problem) {
  return createDisabledMessage(params, problem, _addNoteProblemToMessage);
}
export function getAddIframeDisabledMessage(params, problem) {
  return createDisabledMessage(params, problem, _addIframeProblemToMessage);
}